export default __webpack_public_path__ + "static/media/drop-2-green.a0c9b8fe.jpg";